"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeMode = FreeMode;
const preact_1 = require("preact");
const typestyle_1 = require("typestyle");
const style_1 = require("./style");
const Controls_style_1 = require("../Controls.style");
const SettingsButton_1 = require("../Buttons/SettingsButton");
const VisualSettingsButton_1 = require("../Buttons/VisualSettingsButton");
const FullscreenButton_1 = require("../Buttons/FullscreenButton");
const HelpButton_1 = require("../Buttons/HelpButton");
function FreeMode(props) {
    return ((0, preact_1.h)("div", { class: (0, typestyle_1.classes)(props.class, style_1.FreeModeStyle.controls) },
        (0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.buttons },
            (0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.left }),
            (0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.right },
                (0, preact_1.h)(HelpButton_1.HelpButton, null),
                (0, preact_1.h)(VisualSettingsButton_1.VisualSettingsButton, { game: props.game }),
                (0, preact_1.h)(SettingsButton_1.SettingsButton, { game: props.game }),
                (0, preact_1.h)(FullscreenButton_1.FullscreenButton, { active: false, root: props.root })))));
}
